import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description: string;
  structuredData?: Record<string, unknown>[];
}

function upsertMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

export function useSeo({ title, description, structuredData }: SeoOptions) {
  const structuredDataJson = JSON.stringify(structuredData ?? []);

  useEffect(() => {
    document.title = title;
    upsertMeta('description', description);

    const data = JSON.parse(structuredDataJson) as Record<string, unknown>[];
    const scripts = data.map((item) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.leonardoSeo = 'true';
      script.text = JSON.stringify(item);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scripts.forEach((script) => script.remove());
    };
  }, [description, structuredDataJson, title]);
}
